
import { Component, Vue } from 'vue-property-decorator'
import { namespace, Getter, State } from 'vuex-class'
import OzIcon from 'library/v4/components/OzIcon.vue'
import OzContainedButton, { OzContainedButtonColorScheme } from 'library/v4/components/OzContainedButton.vue'

@Component({
  components: {
    OzIcon,
    OzContainedButton,
  },
})
export default class SurfaceAddPostButton extends Vue {
  @State isEmbedded!: boolean
  @Getter isMap!: boolean
  @namespace('browser').State darkMode!: boolean | 'auto'
  @namespace('map').Action startPickingLocation!: () => void
  @namespace('post').Action startNewPost!: () => void

  @Getter skinAccentColorAsRGB!: string
  @Getter skinAccentTextColor!: 'black' | 'white' | null

  OzContainedButtonColorScheme = OzContainedButtonColorScheme
  isHovered = false

  get useSkinColors(): boolean {
    return !!this.skinAccentColorAsRGB && !!this.skinAccentTextColor
  }

  get isButtonSkinColorDark(): boolean {
    return this.skinAccentTextColor === 'white'
  }

  get skinColorCssVariables(): Record<string, any> {
    if (!this.useSkinColors) {
      return {}
    }

    return {
      '--wall-skin-accent-color': this.skinAccentColorAsRGB,
      '--wall-skin-accent-text-color': this.skinAccentTextColor,
    }
  }

  setHover(isHovered: boolean): void {
    this.isHovered = isHovered
  }
}
